var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Head'),_c('main',[_c('router-view')],1),_c('Footer'),_c('a-back-top',{attrs:{"visibilityHeight":1000}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }